import { IconProps } from "../../types/icon";

export default function UnMuteIcon({
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1436_9807)">
        <path
          d="M19.3685 18.1125H13.3664C12.3902 18.1125 11.5977 18.905 11.5977 19.8812V29.1888C11.5977 30.165 12.3902 30.9575 13.3664 30.9575H19.3685L27.1199 37.7425C27.8931 38.419 29.0916 37.8681 29.0916 36.8436V12.2264C29.0916 11.2019 27.8835 10.6607 27.1199 11.3276L19.3685 18.1125Z"
          stroke={color}
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M31.5273 28.8988C33.1124 28.2803 34.2529 26.7435 34.2529 24.9361C34.2529 23.1287 33.1124 21.592 31.5273 20.9734"
          stroke={color}
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M33.0938 32.7939C36.2446 31.5665 38.5062 28.5123 38.5062 24.9362C38.5062 21.36 36.2446 18.3058 33.0938 17.0784"
          stroke={color}
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M24.539 48.5964C37.8251 48.5964 48.5956 37.8259 48.5956 24.5398C48.5956 11.2537 37.8251 0.483154 24.539 0.483154C11.2529 0.483154 0.482422 11.2537 0.482422 24.5398C0.482422 37.8259 11.2529 48.5964 24.539 48.5964Z"
          stroke={color}
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1436_9807">
          <rect width="49.0701" height="49.0701" fill={color}></rect>
        </clipPath>
      </defs>
    </svg>
  );
}
